var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Table',{attrs:{"rows":_vm.rows,"columns":_vm.columns,"columnID":"idx"}})
}
var staticRenderFns = []

export { render, staticRenderFns }